module.exports = __webpack_public_path__ + "static/media/sidebar-toggler.52ba0a94.svg";